import { Box, Skeleton } from '@mui/material';
import { MediaSkeletonLoaderOverlay } from './MediaSkeletonLoaderOverlay';

interface FragmentMediaPlayerSkeletonProps {
  /** CSS aspect-ratio value matching the target player layout (e.g. `16 / 9`). */
  aspectRatio: string;
  showLoader?: boolean;
  /** Export progress percent while the media asset is being generated. */
  progressPercent?: number;
}

/**
 * Shared skeleton shell for fragment audio/video players: rectangular placeholder
 * with an optional centered in-progress loader overlay.
 */
export function FragmentMediaPlayerSkeleton({
  aspectRatio,
  showLoader = true,
  progressPercent,
}: FragmentMediaPlayerSkeletonProps) {
  return (
    <Box sx={{ margin: '0 auto' }}>
      <Box sx={{ position: 'relative', width: '100%', aspectRatio }}>
        <Skeleton variant="rectangular" sx={{ width: '100%', height: '100%', borderRadius: 1 }} />
        {showLoader && <MediaSkeletonLoaderOverlay progressPercent={progressPercent} />}
      </Box>
    </Box>
  );
}
